/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Status } from './Status';
// @ts-ignore
import {
// @ts-ignore
    StatusFromJSON,
// @ts-ignore
    StatusFromJSONTyped,
// @ts-ignore
    StatusToJSON,
} from './Status';

/**
 * 
 * @export
 * @interface RetailerUpdateRequest
 */
export interface RetailerUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof RetailerUpdateRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerUpdateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerUpdateRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof RetailerUpdateRequest
     */
    currencyCode: string;
    /**
     * 
     * @type {Status}
     * @memberof RetailerUpdateRequest
     */
    status?: Status;
    /**
     * 
     * @type {string}
     * @memberof RetailerUpdateRequest
     */
    externalCode: string;
}

/**
 * Check if a given object implements the RetailerUpdateRequest interface.
 */
// @ts-ignore
export function instanceOfRetailerUpdateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "organizationId" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "currencyCode" in value;
    isInstance = isInstance && "externalCode" in value;

    return isInstance;
}

// @ts-ignore
export function RetailerUpdateRequestFromJSON(json: any): RetailerUpdateRequest {
    return RetailerUpdateRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function RetailerUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetailerUpdateRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'organizationId': json['organization_id'],
        'name': json['name'],
        'email': json['email'],
        'currencyCode': json['currency_code'],
        'status': !exists(json, 'status') ? undefined : StatusFromJSON(json['status']),
        'externalCode': json['external_code'],
    };
}

// @ts-ignore
export function RetailerUpdateRequestToJSON(value?: RetailerUpdateRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'organization_id': value.organizationId,
        'name': value.name,
        'email': value.email,
        'currency_code': value.currencyCode,
        'status': StatusToJSON(value.status),
        'external_code': value.externalCode,
    };
}

